import _styled from "@emotion/styled-base";
/* eslint-disable id-blacklist, no-restricted-imports */
import { variables as vars } from '@domain-group/fe-brary';
var font = vars.font;
export var StatisticsContainer = _styled("div", {
  target: "e18sdcwj0"
})("margin:18px -8px -8px;display:flex;flex-direction:row;flex-wrap:wrap;align-content:flex-start;font-size:", font.baseFontSize, ";line-height:", font.smallLineHeight, ";");
export var Item = _styled("span", {
  target: "e18sdcwj1"
})({
  name: "3wxo3x",
  styles: "margin:0 8px;padding-bottom:8px;display:flex;flex:1 1 0;"
});
export var Label = _styled("span", {
  target: "e18sdcwj2"
})({
  name: "q91zzj",
  styles: "font-weight:normal;white-space:nowrap;"
});
export var Value = _styled("span", {
  target: "e18sdcwj3"
})("display:inline-block;white-space:nowrap;font-weight:", font.headingFontWeight, ";margin-bottom:-1px;");
export var Suffix = _styled("span", {
  target: "e18sdcwj4"
})("display:inline-block;font-size:", font.smallFontSize, ";font-weight:normal;");